import { Category } from '@msdyn365-commerce/retail-proxy';

export const renderImageUrls = (imageBaseURL: string, subCategoryDetails: Category | undefined, maxImagesToShow: number): string[] => {
    const imageUrls: string[] = [];
    for (let i = 1; i <= maxImagesToShow; i++) {
        imageUrls.push(`${imageBaseURL}${subCategoryDetails?.Name?.replace('&','And').replace(/\b(?<!')[a-z]/g, (match) => match.toUpperCase()).replace(',','')}__CDP__00${i}.jpg`);
    }
    return imageUrls;
};